<template>
	<router-view />
</template>

<style>
body {
	font-family: 'Roboto Condensed', sans-serif !important;
}

.ant-typography {
	color: #fff !important;
}

.ant-typography.ant-typography-success {
	color: #52c41a !important;
}

.ant-typography.ant-typography-danger {
	color: #ff4d4f !important;
}

.ant-btn:not(.ant-btn-circle) {
	border-radius: 6px !important;
}

.ant-btn.ant-btn-primary {
	font-size: 14px;
	font-weight: 500;
	background-color: #58a6cd;
	border-color: #58a6cd;
}

.no-click {
	cursor: default !important;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
	background-color: #58a6cd !important;
	border-color: #58a6cd !important;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover::before,
.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner,
.ant-picker-range .ant-picker-active-bar {
	background-color: #58a6cd !important;
}

.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before,
.ant-picker-focused {
	border-color: #58a6cd !important;
}

.ant-radio-button-wrapper:first-child {
	border-radius: 6px 0 0 6px !important;
}

.ant-radio-button-wrapper:last-child {
	border-radius: 0 6px 6px 0 !important;
}

.ant-skeleton-element.text-skeleton .ant-skeleton-button {
	width: 120px !important;
}
</style>
